import { observable, action, runInAction } from 'mobx';
import { PAGE_SIZE_DEFAULT } from '../constants/appConstant';
import customerMasterDataAPI from '../apis/customerMasterDataAPI'
import alertMessage from '../utils/alertMessage'

export default class CustomerMasterDataStore {
  constructor(rootStore) {
      this.rootStore = rootStore;
  }
  @observable isFetching = false;
  @observable pageSize = PAGE_SIZE_DEFAULT;
  @observable pageNo = 1;
  @observable currIndex = 0
  @observable itemCount = 0;

  @observable nameList = []
  @action
  async onGetNameAction(params) {
    this.isFetching = true;
    try {
      this.nameList = [];
      const response = await customerMasterDataAPI.getNameAction(params);
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          this.nameList = response.data.data || []
        }
      })
    } catch (err) {
      alertMessage.error(err.message);
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  @observable typeList = []
  @action
  async onGetTypeAction() {
    this.isFetching = true;
    try {
      this.typeList = [];
      const response = await customerMasterDataAPI.getTypeAction({dictionaryType: 'MASTER_DATA'});
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 200) {
          this.typeList = response.data.data || []
        }
      })
    } catch (err) {
      alertMessage.error(err.message);
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*SearchResult start*/
  @observable searchItem = {
    "customer": "",
    "names": [],
    "type": ''
  }
  @observable masterDataList = []
  @action
  async onSearchMasterDataAction(params,pageNo,pageSize) {
    this.isFetching = true;
    this.masterDataList = [];
    this.pageNo = pageNo;
    this.pageSize = pageSize;
    this.itemCount = 0
    try {
      const response = await customerMasterDataAPI.searchAction(params,pageNo,pageSize);
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          this.masterDataList = response.data.data?.records || []
          this.itemCount = response.data.data?.total
          this.searchItem = params;
        }
      })
    } catch (err) {
      alertMessage.error(err.message);
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  onSearchMasterDataClear(params,pageNo,pageSize) {
    try {
      runInAction(() => {
        this.masterDataList = [];
        this.pageNo = pageNo;
        this.pageSize = pageSize;
        this.itemCount = 0
        this.searchItem = params;
      })
    } catch (err) {
      alertMessage.error(err.message);
    }
  }
  @action
  onChangeMasterDataList(value){
    this.masterDataList=value
    this.itemCount= 0
  }
  /*SearchResult end*/
  /*add permission*/
  @action
  async onAddMasterDatanAction(params){
    this.isFetching = true
    let oldParams = JSON.parse(JSON.stringify(params))
    try {
      const response = await customerMasterDataAPI.addAction(params)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Add Success！')
          if( oldParams.type && oldParams.type === 'parameter') {
            this.onSearchMasterDataAction({...this.searchItem, type: oldParams.type},this.pageNo,this.pageSize)
          }else {
            this.onSearchMasterDataAction(this.searchItem,this.pageNo,this.pageSize)
          }
        }else {
          alertMessage.error('Add Failed！' + response.data.message +'')
        }
      })
      return response
    } catch (err) {
      runInAction(() => {
        this.isFetching = false;
      });
      return err
    }
  }
  /*get edit permission*/
  @observable detailsObj= null
  @action
  async onGetMasterDataAction(params){
    let oldParams = JSON.parse(JSON.stringify(params))
    this.isFetching = true
    try {
      let response = {}
      if( oldParams.type && oldParams.type === 'parameter') {
        response = await customerMasterDataAPI.getAction({...params, type: oldParams.type})
      } else {
        response = await customerMasterDataAPI.getAction({...this.searchItem, id: params.id})
      }
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          this.detailsObj=response.data.data || null
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*edit permission*/
  @action
  async onEditMasterDataAction(params,id){
    let oldParams = JSON.parse(JSON.stringify(params))
    this.isFetching = true
    try {
      const response = await customerMasterDataAPI.editAction(params,id)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Edit Success！')
          if( oldParams.type && oldParams.type === 'parameter') {
            this.onSearchMasterDataAction({...this.searchItem, type: oldParams.type},this.pageNo,this.pageSize)
          }else {
            this.onSearchMasterDataAction(this.searchItem,this.pageNo,this.pageSize)
          }
        }else {
          alertMessage.error('Edit Failed！' + response.data.message +'')
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*delete permission*/
  @action
  async onDeleteMasterDataAction(params) {
    let oldParams = JSON.parse(JSON.stringify(params))
    this.isFetching = true
    try {
      const response = await customerMasterDataAPI.deleteAction(params);
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Delete Success！')
          if( oldParams.type && oldParams.type === 'parameter') {
            this.onSearchMasterDataAction({...this.searchItem, type: oldParams.type},this.pageNo,this.pageSize)
          }else {
            this.onSearchMasterDataAction(this.searchItem,this.pageNo,this.pageSize)
          }
        }else {
          alertMessage.error('Delete Failed！' + response.data.message +'')
        }
      });
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return;
    }
    runInAction(() => {
      this.pageNo = pageNo;
      this.pageSize = pageSize;
    });
    this.onSearchMasterDataAction(this.searchItem,this.pageNo,this.pageSize)
  }

  /*customer update value*/
  @observable customerValue=''
  @action
  onChangeCustomer(value){
    this.customerValue = value
    this.searchItem = {
      "customer": value,
    }
  }
  /*customer update value*/
  @observable namesValue=''
  @action
  onChangeNames(value){
    this.namesValue = value
  }
  /*customerStr update value*/
  @observable customerStr=''
  @action
  onChangeCustomerStr(str){
    this.customerStr = str
  }
}
